/** Surbrillance persistante d'un champ à renseigner (demande d'Alexis du 01/11/2026 : « lors du parcours les champs à
 *  remplir se mettent aussi en surbrillance, jusqu'à ce qu'ils soient renseignés »). Distincte de la désignation
 *  éphémère (`designate`, attention.ts : clignotement puis pulsation de 4,8 s) : un état, pas un geste. Tant que le
 *  préalable manque, le contrôle porte un anneau d'accent doux et un fond légèrement teinté ; le champ attendu
 *  (`next`) est un peu plus marqué que les autres préalables (`missing`). Renseigné, il s'éteint en fondu.
 *
 *  Emploi : l'attribut `data-awaiting` sur le contrôle visible (le cadre du champ : `<input className={inputClass}>`,
 *  bouton de `Select`, cadre de `SearchField`), posé par la prop `awaiting` des composants partagés ou directement.
 *  Un contrôle qui peut attendre porte toujours l'attribut, à `off` une fois renseigné : la transition du fondu
 *  reste ainsi déclarée quand la surbrillance s'éteint (classes d'index.css, « Champ à renseigner »).
 *
 *  Coexistence : un appui sur « Ensuite » ou sur le bouton bloqué désigne le champ (`designate`) ; le clignotement
 *  (animation Web) passe par-dessus, puis la pulsation `.wayfinding` part de l'anneau de la surbrillance au lieu de
 *  l'effacer. Mouvement réduit : ni pulsation, un halo fixe ; le fondu des couleurs reste. */

/** `next` : le champ attendu ; `missing` : un autre préalable ; `off` : renseigné (ou rien d'attendu). */
export type Awaiting = "next" | "missing" | "off";

/** Surbrillance d'un champ parmi les champs attendus (`off` s'il n'y figure pas). */
export function awaitingFor<F extends string>(fields: Partial<Record<F, Exclude<Awaiting, "off">>>, field: F): Awaiting {
  return fields[field] ?? "off";
}

/** Attribut à poser sur le contrôle : rien quand la prop n'est pas donnée (contrôle qui n'attend jamais rien). */
export function awaitingAttr(awaiting: Awaiting | undefined): { "data-awaiting"?: Awaiting } {
  return awaiting === undefined ? {} : { "data-awaiting": awaiting };
}
